import { Outlet } from 'react-router';
import { ErrorBoundary } from '@/components/common';
import { Sidebar } from '@/components/layout';

/**
 * The shell every signed-in page renders inside.
 *
 * The error boundary sits *inside* the shell rather than around it, so a broken
 * page still leaves the user with navigation and a way out.
 */
export function RootLayout() {
  return (
    <Sidebar>
      <ErrorBoundary>
        <Outlet />
      </ErrorBoundary>
    </Sidebar>
  );
}
